import { createReducer } from "@reduxjs/toolkit";
import { UserState } from "../actions/User/types";
import { constantsReceived, getCurrentUser, receivedCurrentUser } from "actions";

const initialState: UserState = {
    currentUser: null,
    isCurrentUserReceived: false,
    constants: null
};

const userState = createReducer(initialState, (builder) => {
    builder
        .addCase(getCurrentUser, (state) => {
            state.isCurrentUserReceived = false;
        })
        .addCase(receivedCurrentUser, (state, action) => {
            state.isCurrentUserReceived = true;
            state.currentUser = action.payload.currentUser;
        })
        .addCase(constantsReceived, (state, action) => {
            state.constants = action.payload.constants;
        })
        .addDefaultCase((state) => state);
});

export default userState;
